module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_chapel_2-1845fe4ce5856507027fc1adddcd9823.jpg";